/* Source: src/mt-includes/js/src/moto_link/init.js*/
angular.module('website.moto_link', ['website.backend.RenderService']);
